import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscore',
})
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (!value) {
      return ' ';
    } else {
      let arr = value.split('_');
      let newStr = '';
      arr.map((word) => (newStr = newStr + ' ' + word));
      return newStr.trim();
    }
  }
}
